import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '100vw',
    height: 'calc(100vh - 64px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: 16,
    paddingTop: '3rem',
    gap: '2.5rem',
  },
  textContent: {
    width: '90vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '0.75rem',
    
    '& > p' : {
      maxWidth: '50%',
      fontSize: 14,
    },
  },
  tabWrapper: {
    width: '90vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    borderRadius: '5px',
    border: `solid 1px ${Colors.lightGray}`,
    padding: '1.25rem',
    backgroundColor: Colors.lightGray,
  },
  panel: {
    width: '100%',
    height: '100%',
    borderRadius: '5px',
    border: `solid 1px ${Colors.gray}`,
    padding: '1.25rem',
    backgroundColor: Colors.white,
  },
}))

export default styles
